import { useDialog } from '@/context/dialogContext'
import { useAppSelector } from '@/redux/hooks'
import { routes } from '@/routes/routes'
import React, { useState } from 'react'
import { Menu, X } from 'react-feather'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import GGOOLLFF from '@/assets/images/logo.png'

const GNBContainer = styled.nav`
  display: flex;
  gap: 20px;

  @media (max-width: 768px) {
    display: none;
  }
`

const MenuItem = styled.div`
  cursor: pointer;
  text-decoration: none;
  color: #333333;
  font-size: 1.1rem;
  font-weight: 600;
  transition: color 0.3s ease;

  &.active {
    color: #ff7043;
  }

  &:hover {
    color: #ff7043;
  }

  &:focus {
    outline: none;
  }

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`

const MobileMenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #333;
  @media (max-width: 768px) {
    display: block;
    position: relative;
    z-index: 110;
  }
`

const MobileMenuOverlay = styled.div<{ isOpen: boolean }>`
  display: ${(props) => (props.isOpen ? 'flex' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 100;

  a {
    color: #ffffff;
    font-size: 1.25rem;
    font-weight: bold;
    margin: 15px 0;
    text-transform: uppercase;
    letter-spacing: 1px;
    transition: color 0.3s ease;

    &:hover {
      color: #ff7043;
    }
  }
  @media (max-width: 480px) {
    a {
      font-size: 1.1rem;
      margin: 12px 0;
    }
  }
`

const CloseButton = styled(X)`
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 1.5rem;
  color: #ffffff;
  cursor: pointer;
  z-index: 110;
`

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 99;
`

const Sidebar = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 80%;
  max-width: 300px;
  height: 100vh;
  background-color: #ffffff;
  z-index: 100;
  display: flex;
  flex-direction: column;
  padding: 24px 20px;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.2);
  animation: slideIn 0.3s ease-out forwards;

  @keyframes slideIn {
    from {
      transform: translateX(-100%);
    }
    to {
      transform: translateX(0%);
    }
  }
`

const SidebarCloseButton = styled(X)`
  align-self: flex-end;
  cursor: pointer;
  margin-bottom: 20px;
`

const SidebarMenuItem = styled.div`
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  margin: 12px 0;
  cursor: pointer;

  &.active {
    color: #ff7043;
  }

  &:hover {
    color: #ff7043;
  }
`
const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between; //핵심
  cursor: pointer;
  margin-bottom: 20px;

  img {
    height: 40px;
    width: auto;
  }
`

const GNB: React.FC = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false)
  const { isAuthenticated } = useAppSelector((state) => state.auth)
  const location = useLocation()
  const navigate = useNavigate()
  const { showConfirm, showAlert } = useDialog()

  const toggleMobileMenu = () => {
    setMobileMenuOpen((prev) => !prev)
  }

  // const handleMenuClick = (path: string, requireAuth?: boolean) => {
  const handleMenuClick = (route: any) => {
    const path = route.path || '/'
    if (route.notReady) {
      showAlert({
        type: 'warning',
        message: '서비스 준비중입니다.',
        // title?: string | React.ReactNode
        btnName: '확인',
        onClose: () => {},
      })
      return
    }
    /* //2025.03.19 ljh 정보제공 목적으로 로그인 후 이용 옵션 제거
    if (route.requireAuth && !isAuthenticated) {
      alert(path)
      if (path === '/golf/detailSearch') {
        showConfirm({
          title:
            '로그인 후 골프장검색 메뉴에서 이용할 수 있는 옵션이에요. 로그인화면으로 이동할까요?',
          onConfirm() {
            navigate('/login', {
              state: {
                redirectTo: '/golf/detailSearch',
              },
            })
          },
        })
      }
      return
    }
    */

    if (location.pathname === path) {
      navigate(0)
    } else {
      navigate(path)
    }
    setMobileMenuOpen(false)
  }

  const isMenuItemActive = (path: string) => {
    return location.pathname.startsWith(path)
  }
  const handleMainLogoClick = () => {
    navigate('/main')
  }
  return (
    <>
      <MobileMenuButton onClick={toggleMobileMenu}>
        {isMobileMenuOpen ? null : <Menu />}
      </MobileMenuButton>

      {isMobileMenuOpen && (
        <Overlay onClick={toggleMobileMenu}>
          <Sidebar onClick={(e) => e.stopPropagation()}>
            <LogoWrapper>
              <img
                src={GGOOLLFF}
                alt="꿀프 메인 로고"
                onClick={handleMainLogoClick}
              />
              <SidebarCloseButton onClick={toggleMobileMenu} />
            </LogoWrapper>
            {routes
              .filter((route) => route.label)
              .map((route, index) => (
                <SidebarMenuItem
                  key={index}
                  onClick={() => handleMenuClick(route)}
                  className={isMenuItemActive(route.path ?? '') ? 'active' : ''}
                >
                  {route.label}
                </SidebarMenuItem>
              ))}
          </Sidebar>
        </Overlay>
      )}

      <GNBContainer>
        {routes
          .filter((route) => route.label)
          .map((route, index) => (
            <MenuItem
              key={index}
              onClick={() =>
                // handleMenuClick(route.path ?? '/', route.requireAuth)
                handleMenuClick(route)
              }
              className={isMenuItemActive(route.path ?? '') ? 'active' : ''}
            >
              {route.label}
            </MenuItem>
          ))}
      </GNBContainer>
    </>
  )
}
export default GNB
